import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { urls } from 'app-constants';
import { getCsrfToken } from 'utils';
import Icon from 'components/Icon';
import PillButton from 'components/PillButton';
import Map from './Map';

const ResultItem = ({ pois, mapZoom, mapboxToken, onResolveSuccess }) => {
  const mapCoords = pois.map(({ lon, lat }) => [lon, lat]);

  const [isFetching, setIsFetching] = useState(false);
  const handleResolveClick = () => {
    setIsFetching(true);

    fetch(urls.poiDuplicateResolve, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'X-CSRFToken': getCsrfToken(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ pois: pois.map(item => item.id) }),
    })
      .then(response => {
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
      })
      .then(data => {
        handleResolveSuccess(data.pois);
      })
      .catch(err => {
        setIsFetching(false);
        console.error(err);
      });
  };

  const [isResolved, setIsResolved] = useState(false);
  const handleResolveSuccess = poiIds => {
    setIsResolved(true);
    setTimeout(() => onResolveSuccess(poiIds), 300);
  }

  return (
    <div
      className="listings-card bordered noclick mb-4 position-relative"
      style={{
        opacity: isResolved ? 0 : 1,
        transition: 'opacity .3s ease-out',
      }}
    >
      <div className="lc-top">
        <div className="me-2" style={{ borderRadius: 8, overflow: 'hidden', flex: '0 0 300px' }}>
          <Map
            zoom={mapZoom}
            coords={mapCoords}
            mapboxToken={mapboxToken}
            width={300}
            height={200}
          />
        </div>
        <div className="lc-main" style={{ gap: 20 }}>
          {pois.map(({ id, name, absoluteUrl, shortAddress }) => (
            <div key={id} style={{ flex: 'unset' }}>
              <h5 className="mb-1">
                <a href={absoluteUrl} target="_blank" rel="noopener noreferrer">{name}</a>
              </h5>
              <div className="lh-sm d-flex align-items-center">
                <div className="me-1 d-flex justify-content-center" style={{ flex: '0 0 20px', color: '#cacaca' }}>
                  <Icon i="map-marker-alt" size="sm" />
                </div>
                <div>{shortAddress}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ position: 'absolute', top: 15, right: 15 }}>
          <PillButton
            className="subtle"
            isDisabled={isFetching}
            showLoadingOverlay={isFetching}
            prependIcon={['far', 'check']}
            text="Mark Resolved"
            onClick={handleResolveClick}
          />
        </div>
      </div>
    </div>
  );
};

ResultItem.propTypes = {
  pois: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    lon: PropTypes.number,
    lat: PropTypes.number,
    absoluteUrl: PropTypes.string,
    published: PropTypes.bool,
    street: PropTypes.string,
    shortAddress: PropTypes.string,
  })),
  mapZoom: PropTypes.number,
  mapboxToken: PropTypes.string,
  onResolveSuccess: PropTypes.func,
};

export default ResultItem;
